export default __webpack_public_path__ + "static/media/search-outline.753cfc45.svg";